import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Mail } from '../../interfaces/mail.interface';
import {
  MatCheckboxChange,
  MatCheckboxModule
} from '@angular/material/checkbox';
import { MailService } from '../../services/mail.service';
import { VexStripHtmlPipe } from '@vex/pipes/vex-strip-html/vex-strip-html.pipe';
import { VexDateFormatRelativePipe } from '@vex/pipes/vex-date-format-relative/vex-date-format-relative.pipe';
import { MailLabelComponent } from '../mail-label/mail-label.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';

@Component({
    selector: 'vex-mail-list-entry',
    templateUrl: './mail-list-entry.component.html',
    styleUrls: ['./mail-list-entry.component.scss'],
    imports: [
        MatCheckboxModule,
        MatRippleModule,
        MatIconModule,
        NgClass,
        NgFor,
        NgIf,
        MailLabelComponent,
        VexDateFormatRelativePipe,
        VexStripHtmlPipe
    ]
})
export class MailListEntryComponent implements OnInit {
  @Input({ required: true }) mail!: Mail;
  @Input() selected: boolean = false;
  @Output() selectedChange = new EventEmitter<boolean>();

  hovered: boolean = false;

  constructor(
    private cd: ChangeDetectorRef,
    private mailService: MailService
  ) {}

  ngOnInit(): void {}

  isCheckboxVisible() {
    return this.selected || this.hovered;
  }

  isStarVisible() {
    return this.mail?.starred || this.isCheckboxVisible();
  }

  onMouseEnter() {
    this.hovered = true;
    this.cd.markForCheck();
  }

  onMouseLeave() {
    this.hovered = false;
    this.cd.markForCheck();
  }

  onCheckboxChange(event: MatCheckboxChange) {
    this.selectedChange.emit(event.checked);
  }

  toggleStar(event: MouseEvent) {
    event?.preventDefault();
    event?.stopPropagation();
    this.mailService.toggleStar(this.mail.id);
    this.cd.markForCheck();
  }

  markMailAsRead(mailId: Mail['id']) {
    if ((this.mail?.folder || '').toUpperCase() === 'DRAFT') {
      this.mailService.openDraft(mailId);
      return;
    }

    this.mailService.selectMail(mailId);
  }
}
